<script>

export default {
  name: "ManageUsers",
  data() {
    return {
      usrs: '',
      usrSearch: '',

    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredUsrs() {
      if (!this.usrSearch) {
        return this.usrs;
      }
      return this.usrs.filter(usr =>
          usr.firstname.toLowerCase().includes(this.usrSearch.toLowerCase())
          || usr.lastname.toLowerCase().includes(this.usrSearch.toLowerCase())
          || usr.dni.toLowerCase().replace(/-/g, '').includes(this.usrSearch.toLowerCase())
      );
    }
  },
  methods: {
    async getUsrs() {
      try {
        let result = await this.$api.get("/auth/users")
        if (result.status.toString() === "200") {
          this.usrs = result.data
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la informacion',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async editUsr(id) {
      this.$router.push({name: 'EditUsr', params: {id: id}})
    },
    limitUsrSearch() {
      this.usrSearch = this.usrSearch.replace(/[^a-z0-9]/gi, '').trimStart();
    }
  },
  created() {
    this.getUsrs()
  }

}
</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Usuarios</h1>

      <div :class="sidebarData.includes('ad-prov-invoice-reg') ? 'subOpt' : 'subOptCenter'">
        <div>
        <input type="text" v-model="usrSearch" v-on:input="limitUsrSearch"
               placeholder="Buscar usuario ...">
        </div>
        <div>
        <button role="link" @click="$router.push('/scene/regusr')">Registrar nuevo usuario</button>
        </div>
      </div>


      <div class="table-container mt-4" v-if="filteredUsrs.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>DNI</th>
            <!--<th>Status</th>
            <th>Opciones</th>-->


          </tr>

          </thead>
          <tbody>

          <tr v-for="(usr, index) in filteredUsrs" :key="usr.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ usr.firstname }} {{ usr.lastname }}</td>
            <td>{{ usr.dni }}</td>
            <!--<td>{{ usr.ustatus }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="editUsr(usr.id)" role="link">Editar</button>
            </td>-->
          </tr>

          </tbody>

        </table>
      </div>
      <div v-else>
        <p>No hay usuarios disponibles.</p>
      </div>


    </div>
  </div>


</template>


<style>

.subOpt {
  grid-template-columns: 1fr 1fr;
  display: grid;
  justify-content: space-between;
  gap: 20px;
  width: 800px;
  margin: auto;
}

</style>